import { APIConfiguration } from '@savgroup-front-common/configuration';
import { logVerbose } from '@savgroup-front-common/configuration/appInsights/AppInsights';
import { BaseBackResponse } from '@savgroup-front-common/types';

import { getCurrentLanguage } from '../helpers/intl';

import { Config } from './apiCall.types';
import APIClient from './APIClient';
import {
  getIsSessionCookieModeEnabled,
  toSameOriginApiUrl,
} from './sessionCookieMode';
import { userManager } from './userManager';

export type { Config };

const apiCall = async <T = BaseBackResponse>(
  url: string,
  config: Config,
): Promise<T> => {
  if (typeof url !== 'string') {
    throw new Error(`Url should be string got: ${typeof url}`);
  }

  if (getIsSessionCookieModeEnabled()) {
    return APIClient({
      url: toSameOriginApiUrl(url),
      config,
      currentLanguage: getCurrentLanguage(),
      authToken: undefined,
    });
  }

  if (!userManager) {
    return APIClient({
      url,
      config,
      currentLanguage: getCurrentLanguage(),
      authToken: undefined,
    });
  }

  const user = await userManager.getUser();

  let accessToken = null;

  if (user && !user.expired && user.access_token.length > 43) {
    accessToken = user.access_token;
  } else if (user && (user.expired || user.access_token.length <= 43)) {
    await userManager.signinSilent({
      resource: APIConfiguration.apiBase,
    });

    accessToken = (await userManager.getUser())?.access_token;
  } else {
    logVerbose('User is not logged in');

    sessionStorage.clear();
  }

  return APIClient({
    url,
    config,
    currentLanguage: getCurrentLanguage(),
    authToken: accessToken,
  });
};

export default apiCall;
